<template>
<fieldset :class="$style.labelsSection">
    <legend :class="$style.labelsSectionLegend">
        <span>
            {{type}} Name
        </span>
    </legend>

    <template v-for="language in languages">
        <div :key="(id ? id+'_' : '')+'label_'+language.code" :class="$style.labelsNameEditorSection">
            <div style="width: 45%;">
                <span :class="$style.labelsNameEditorLabel">{{language.name}}</span>
                <br>
                <editor
                    v-model="values[language.code]"
                    api-key="vjwto0uux6l25qp5q562n4506qp5s5s615aruwxt2x4m5mt5"
                    :init="editorInit"
                /> 
            </div>
            <div style="width:45%;">
                <span :class="$style.labelsNameEditorLabel">Preview</span>
                <fieldset v-html="values[language.code]">
                </fieldset>
            </div>
        </div>
    </template>
</fieldset>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
export default {
    name: 'label-editor',
    props: {
        id: {
            type: String,
            required: false
        },
        type: {
            type: String,
            required: false,
            default: "Label"
        },
        languages: {
            type: Array,
            required: true
        },
        content: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: false,
            default: 0
        }
    },
    components: {
        Editor
    },
    created: function(){
        var values = JSON.stringify(this.content);
        this.values = JSON.parse(values);
    },
    data: function(){
        return {
            values: {},
            editorInit:{
                height: 150,
                menubar: false,
                plugins: ['lists', 'paste'],
                toolbar:
                'formatselect | bold italic underline| \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | superscript subscript | paste',
                paste_as_text: true
            }
        }
    },
    watch: {
        values: {
            deep: true,
            handler: function(){
                this.$emit('update',{
                    values: this.values,
                    index: this.index,
                    content: this.content
                });
            }
        }
    }
}
</script>

<style module>
.labelsSection {
    border: 1px solid #C1C1C1;
    border-radius: 5px;
}
.labelsSectionLegend {
    text-transform: uppercase; 
    font-size: 14px; 
    color: black
}

.labelsSectionLegend {
    padding: 0 15px;
}

.labelsNameEditorSection {
    display: flex; 
    flex-direction:row;
    justify-content: space-around;
    align-items: flex-start;
    margin: 10px 0;
}

.labelsNameEditorLabel {
    color: black;
    font-size: 14px;
    text-transform: bold;
}

</style>